/**
 * Merge a physical tag doc with its template for the claim UI.
 * Template supplies defaults (e.g. claimTerm); the tag document must win on
 * instance fields (clientId, teamId, paymentDetails, …) or post-claim updates
 * are hidden and the claim flow can spin forever.
 */
export function mergeClaimTagWithTemplate(rawTag, template) {
  if (!rawTag) return null;
  if (!template) {
    return { ...rawTag };
  }
  return {
    ...template,
    ...rawTag,
    id: rawTag.id,
    actionText: {
      ...(template.actionText || {}),
      ...(rawTag.actionText || {}),
    },
  };
}
